"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    height: "24",
    viewBox: "0 0 71.45 24",
    width: "71.45",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", {
    id: "defs5"
  }), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "m70.67 0h-67.34a.78.78 0 0 0 -.78.78v1.07h-1.84a.71.71 0 0 0 -.71.71v12a.71.71 0 0 0 .71.71h1.84v1.18a.78.78 0 0 0 .56.75l3.41 1v5a.78.78 0 1 0 1.56 0v-4.57l3.59 1a.83.83 0 0 0 .22 0h25.11a.78.78 0 1 0 0-1.56h-25l-7.9-2.21v-14.29h65.79v16.57h-5.29a.78.78 0 1 0 0 1.56h6.07a.78.78 0 0 0 .78-.78v-18.13a.78.78 0 0 0 -.78-.79z",
    id: "path1"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m50.74 16.18a3.91 3.91 0 1 0 3.91 3.91 3.91 3.91 0 0 0 -3.91-3.91zm2.35 3.91a2.36 2.36 0 1 1 -2.35-2.36 2.35 2.35 0 0 1 2.35 2.36z",
    id: "path2"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m59.52 16.18a3.91 3.91 0 1 0 3.91 3.91 3.91 3.91 0 0 0 -3.91-3.91zm2.35 3.91a2.35 2.35 0 1 1 -2.35-2.36 2.35 2.35 0 0 1 2.35 2.36z",
    id: "path3"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m42 16.18a3.91 3.91 0 1 0 3.91 3.91 3.91 3.91 0 0 0 -3.91-3.91zm2.35 3.91a2.35 2.35 0 1 1 -2.35-2.36 2.35 2.35 0 0 1 2.31 2.36z",
    id: "path4"
  })), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m45.26 3.34h10.96v10.96h-10.96z",
    id: "path5"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    transform: "matrix(0.72499951,0,0,0.72500041,10.000001,2.2)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 4.46978,0.813004 C 4.57392,0.580258 4.50936,0.310178 4.31083,0.14393 4.11107,-0.022901 3.82362,-0.0468173 3.59707,0.0832642 0.219504,2.02399 -1.02714,7.01317 0.929609,10.7605 2.74994,14.247 3.84859,16.351 2.13301,20.1864 c -0.10414,0.2328 -0.03958,0.5028 0.15895,0.6691 0.19976,0.1668 0.48721,0.1907 0.71376,0.0607 3.37635,-1.9408 4.62299,-6.93 2.66685,-10.679 C 3.85285,6.75126 2.7542,4.6472 4.46978,0.813004 Z m 6.69912,0 C 11.273,0.580258 11.2085,0.310178 11.0099,0.14393 10.8102,-0.022901 10.5227,-0.0468173 10.2962,0.0832642 6.91921,2.02399 5.67257,7.01375 7.62871,10.761 c 1.82033,3.4866 2.91899,5.5906 1.2034,9.426 -0.10414,0.2327 -0.03959,0.5028 0.15895,0.6691 0.19976,0.1668 0.48721,0.1907 0.71376,0.0606 C 13.0812,18.976 14.3278,13.9868 12.3717,10.2378 10.552,6.75126 9.4533,4.6472 11.1689,0.813004 Z M 19.0708,10.2378 C 17.2511,6.75126 16.1524,4.6472 17.868,0.813004 17.9721,0.580258 17.9076,0.310178 17.709,0.14393 17.5093,-0.022901 17.2218,-0.0468173 16.9953,0.0832642 13.6183,2.02399 12.3717,7.01375 14.3278,10.761 c 1.8203,3.4866 2.919,5.5906 1.2034,9.426 -0.1041,0.2327 -0.0396,0.5028 0.159,0.6691 0.1997,0.1668 0.4872,0.1907 0.7137,0.0606 3.3764,-1.9407 4.623,-6.9305 2.6669,-10.6789 z",
    fill: "#da1e28",
    id: "path1-3"
  })));
};

exports["default"] = _default;